var _excluded = ["onClose", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Flex, IconButton } from '@chakra-ui/react';
import { ArrowLeft, Close } from "../Icons";
import { useWizard } from "./useWizard";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var WizardHeader = _ref => {
  var {
    onClose,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var [{
    currentStep,
    totalSteps,
    context
  }, {
    previous
  }] = useWizard();
  var {
    isPreviousEnabled
  } = context;
  return /*#__PURE__*/_jsxs(Flex, _extends({
    bg: "white",
    px: 4,
    textStyle: "body-normal-medium",
    height: 16
  }, props, {
    align: "center",
    boxShadow: "borderBottom",
    justify: "space-between",
    left: 0,
    position: "fixed",
    right: 0,
    top: 0,
    w: "100%",
    zIndex: "docked",
    children: [/*#__PURE__*/_jsx(WizardHeaderButton, {
      "aria-label": "Previous",
      icon: /*#__PURE__*/_jsx(ArrowLeft, {
        boxSize: 6
      }),
      onClick: previous,
      visibility: !isPreviousEnabled ? 'hidden' : undefined
    }), children || "Step " + currentStep + " of " + totalSteps, /*#__PURE__*/_jsx(WizardHeaderButton, {
      "aria-label": "Close",
      icon: /*#__PURE__*/_jsx(Close, {
        boxSize: 6
      }),
      onClick: onClose
    })]
  }));
};

var WizardHeaderButton = props => /*#__PURE__*/_jsx(IconButton, _extends({}, props, {
  variant: "unstyled",
  boxSize: 10
}));
//# sourceMappingURL=WizardHeader.js.map